import { graphql } from '@/generated/gql';

export const RULE_EVALUATION_LOG_QUERY = graphql(/* GraphQL */ `
  query RuleEvaluationLog($ruleId: UUID!, $order: [TsrctRuleEvaluationLogOrder!], $limit: Int, $offset: Int) {
    tesseract {
      rule(id: $ruleId) {
        id
        evaluationLogs(order: $order, limit: $limit, offset: $offset) {
          nodes {
            id
            createdAt
            sequenceNumber
          }
          totalCount
        }
      }
    }
  }
`);
